

<template>
  <br>
  <p class="fw-bold">  حقوق مالکانه و بدهی ها</p>


  <center>
    <table class="table table-striped" style="width: 60vw;" >
      <thead>
      <tr>
        <th style="width: 1vw;"> </th>
        <th>کد  </th>
        <th>عنوان  </th>
        <th>ماهیت حساب  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in allItems" :class="item.parent_id ? `parent_${item.parent_id}` : ''"
          :style="setcolor(item['level'], item.parent_id)">
        <td :id="'itemParent_'+item.id" @click.prevent="showParents(item.id)" scope="row" style="color: white !important; font-size: 1vw; cursor: pointer;">+</td>
        <td>{{item.code}}</td>
        <td>{{item.title}}</td>
        <td>{{item.nature}}</td>



      </tr>

      </tbody>
    </table>
  </center>

  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="addParent"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>    </p>
      <p @click="addParent=!addParent">❌</p>
    </div>
    <div>
      <div class="d-flex  mb-2 w-100 justify-content-evenly">

        <div class="  d-flex flex-column">
          <label class="text-end">عنوان</label>
          <input v-model="name_parent" type="text" class="form-control">
        </div>

        <div class="  d-flex flex-column">
          <label class="text-end">ماهیت حساب</label>
          <select v-model="nature_parent" name="" class="form-control form-select" style="width: 10vw;;" id="">
            <option selected value="افزایشی">افزایشی</option>
            <option value="کاهشی">کاهشی</option>
          </select>
        </div>

      </div>


      <div class="d-flex my-5">
        <button @click="addParent=!addParent" class="btn btn-primary btn-back">بازگشت</button>
        <button style="margin-right: 1vw;"  class="btn btn-primary btn-submit-1" @click.prevent="submit">ثبت</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 88%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteMethod(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p> خطا </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{ errorMessage }}


      <button @click="error=!error">بازگشت</button>
    </div>
  </div>

</template>
<script  >
export  default {
  data(){
    return{
      allItems: [],
      name: '',
      name_parent: '',
      nature_parent: '',
      nature: '',
      item_id: '',
      errorMessage: '',
      error: false,
      InsertModal: false,
      editModal: false,
      deleteModal: false,
      addParent: false,
      editItem: false,
      id_route: this.$route['params']['id'],

    }
  },
  methods:{
    setcolor(level, id) {


      if (parseInt(level) === 0) {
        return 'background: rgb(94, 103, 252) !important'

      }


      if (parseInt(level) === 1) {
        return `background: rgb(134, 209, 255) !important; ${ id ?  ' display: none; background: rgb(134, 209, 255) !important;': ''}`


      }
      if (parseInt(level) === 2) {
        return `background: rgb(186 230 255) !important; ${ id ?  ' display: none; background: rgb(186 230 255)  !important;': ''}`


      } else {
        return `background: rgba(#d9f1ff, 40%) !important; ${ id ?  ' display: none; background: rgba(#d9f1ff, 40%) !important;': ''}`

      }


    },
    showParents(id){
      const elements = document.querySelectorAll(`.parent_${id}`);

      elements.forEach((ele) => {
        if (ele.style.display === 'table-row') {
          ele.style.display = 'none';
          document.querySelector(`#itemParent_${id}`).innerHTML= '+'

        } else {
          ele.style.display = 'table-row';
          document.querySelector(`#itemParent_${id}`).innerHTML= '-'
        }
      });
    },
    addParentMethod(id){
      this.addParent = true
      this.item_id = id
    },
    submit(){
      if (this.item_id){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


        var formdata = new FormData();
        formdata.append('title', this.name_parent)
        formdata.append('nature', this.nature_parent)

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/cash_route/store_parent/${this.item_id}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              this.all()
              this.name_parent=''
              this.nature_parent=''
              this.item_id=''
              this.addParent = false
              return;



            })
            .catch();
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('title', this.name)
      formdata.append('nature', this.nature)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/cash_route/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.all()
            this.name=''
            this.nature=''



          })
          .catch();
    },
    deleteModalMethod(id){
      this.item_id=id
      this.deleteModal=true
    },
    deleteMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/cash_route/delete/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.all()
            this.deleteModal=false

          })
          .catch();
    },
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/cash_route/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items){
              this.allItems.length=0
              response.items.forEach((ele)=>{
                this.allItems.push(ele)
              })
            }


          })
          .catch();
    },
    editParent(id){},
    edit(id){
      this.item_id = id
      this.editItem = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/cash_route/show/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.item){
              this.name=response.item.title
              this.nature=response.item.nature
            }


          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('title', this.name)
      if (this.nature){

        formdata.append('nature', this.nature)
      }

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/cash_route/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.all()
            this.name=''
            this.nature=''
            this.item_id=''
            this.editItem = false




          })
          .catch();
    },
    submit_parent(id){},
  },
  mounted() {
    this.all()
  }
}

</script>
<style scoped>
label{
  font-size: .8vw;
}
</style>